import React from "react";
import "./Footer.css";

export default function Footer () {
    
return (
        <footer>
        <div className="information-container">
            <h1>contact information</h1>
            <ul>
                <li>marvel.plus@marvel.com</li>
                <span className="reserverd-rights">©2022 MARVEL</span>
                <li>
                    <i className="fab fa-github"></i>
                    <a href="https://github.com/LucianaCHA/Final-Project">github</a>
                </li>
            </ul>
        </div>
    </footer>
  )
} 


